module.exports = __webpack_public_path__ + "img/edopomoga-logo-Photoroom.74a0188c.png";